import {
  type ScanBarcodeContent,
  type ScanOrderShipmentSelection,
} from '../types/scanContext.type';

/**
 * Whether a selected order shipment is the one the scanned barcode resolved to.
 * A selection that only knows its transaction - the shipment details drawer - is
 * identified by that, every other surface by the order shipment it renders.
 */
export const matchesScannedOrderShipment = (
  selection: ScanOrderShipmentSelection,
  barcodeContent: ScanBarcodeContent,
): boolean => {
  if (selection.transactionObjectId)
    return selection.transactionObjectId === barcodeContent.transaction_object_id;

  if (!selection.orderObjectId || !selection.batchEntryId) return false;

  return (
    selection.orderObjectId === barcodeContent.order_object_id &&
    selection.batchEntryId === barcodeContent.shipment_id
  );
};
